module.exports = __webpack_public_path__ + "img/exp_2.0539adb0.png";